import styles from "./header.module.css";

function Header() {
  return (<div className={`${styles.Header}`}>
    <div className={`${styles.Container}`}>
      <div className={`${styles.HeadRow}`}>
        <img src="/images/logo2.svg" alt="logo" className={`${styles.HeadLogo}`} />
      </div>
    </div>
  </div>);
}

export default Header;